import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { HsnService } from './hsn.service'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { MatDialog } from '@angular/material/dialog'
import { MasterCommonServices } from '../../quotation/master.common.service'
import { HsnModel } from './hsn.model'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { ReactiveFormsModule } from '@angular/forms'
import { DatatableComponent } from '../../../shared/components/master-datatable/master-datatable.component'

@Component({
  selector: 'app-hsn.master',
  standalone: true,
  imports: [
    CommonModule,
    ToastrModule,
    ReactiveFormsModule,

    DatatableComponent,
  ],
  templateUrl: './hsn.master.component.html',
  styleUrl: './hsn.master.component.css',
})
export class HsnMasterComponent {
  hsnColumns: MasterDatabaseDisplayModel[] = [
    {
      key: 'hsnName',
      displayName: 'Hsn Name',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'addedOn',
      displayName: 'Added Date',
      hiddenDataTable: false,
      hiddenDialog: true,
      type: 'date',
    },
    {
      key: 'id',
      displayName: 'Id',
      hiddenDataTable: true,
      hiddenDialog: true,
      type: 'text',
    },
  ]
  isLoading: boolean = false

  constructor(
    private hsnService: HsnService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public masterCommonService: MasterCommonServices,
  ) {
    this.masterCommonService.getAllHsn()
  }

  openAddUpdateHsnDialog(mode: string, hsn?: HsnModel): void {
    const fields = this.hsnColumns
    const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
      data: { item: hsn || {}, mode, fields },
    })

    dialogRef.afterClosed().subscribe((result) => {
      

      if (result) {
        if (mode === 'update') {
          this.updateHsn(result)
        } else {
          this.addHsn(result)
        }
      }
    })
  }

  addHsn(hsn: any): void {
    this.hsnService.addHsn(hsn).subscribe({
      next: () => {
        this.toastr.success('Hsn Added Successfully!', 'Success')
        this.masterCommonService.getAllHsn()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  updateHsn(hsn: any): void {
    this.hsnService.updateHsn(hsn).subscribe({
      next: () => {
        this.toastr.success('Hsn Updated Successfully!', 'Success')
        this.masterCommonService.getAllHsn()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  deleteHsn(hsn: HsnModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this hsn?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        hsn.isDeleted = true
        this.hsnService.deleteHsn(hsn).subscribe({
          next: () => {
            this.masterCommonService.hsnList = this.masterCommonService.hsnList.filter(
              (p) => p.id !== hsn.id,
            )
            this.toastr.success('Hsn Deleted Successfully!', 'Success')
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }
}
